import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import { router } from "./pages";
import { TabNavigationContextProvider } from "./modules/Shared/contexts/TabNavigationContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfigProvider } from "antd";
import ptBR from "antd/locale/pt_BR";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});
ReactDOM.render(
  <>
    <TabNavigationContextProvider>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider locale={ptBR}>
          <ToastContainer />
          <RouterProvider router={router} />
        </ConfigProvider>
      </QueryClientProvider>
    </TabNavigationContextProvider>
  </>,
  document.getElementById("root")
);
